var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 6.46334V7C12.8329 8.25792 12.4256 9.4819 11.6724 10.4894C10.9193 11.4969 9.86058 12.234 8.65428 12.5906C7.44799 12.9473 6.15873 12.9044 4.97877 12.4685C3.79881 12.0326 2.79137 11.2269 2.10672 10.1716C1.42206 9.11636 1.09687 7.86804 1.17964 6.61285C1.2624 5.35767 1.7487 4.16286 2.56599 3.20663C3.38328 2.2504 4.48778 1.58398 5.71477 1.30675C6.94176 1.02953 8.22548 1.15637 9.3745 1.66834",
    stroke: "#2148C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.33337L7 8.17254L5.25 6.42254",
    stroke: "#2148C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_4818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.04a3727417ee53027cc8409838a7a3d9.svg";
export { ForwardRef as ReactComponent };